module.exports = __webpack_public_path__ + "media/src/images/icon/heart_on-b3c1a9738212dd72448d69b6f5b434f3.png";